import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { DomService } from './services/dom/dom.service';
import { FileSizePipe } from './pipes/file-size.pipe';

/**
 * This module contains common UI components/directives/models
 */
@NgModule({
  declarations: [ClickOutsideDirective, FileSizePipe],
  imports: [CommonModule],
  exports: [ClickOutsideDirective, FileSizePipe],
  providers: [DomService],
})
export class IdeomUiCommonModule {}
